import { useQuery } from '@tanstack/react-query';
import type { ContentCalendar } from '@seo/types';
import { apiGet } from '@/lib/api';
import { isTerminal } from '@/lib/queryClient';

export function useCalendar(id: string | undefined) {
  return useQuery({
    queryKey: ['calendar', id],
    queryFn: () => apiGet<ContentCalendar>(`/v1/calendars/${id}`),
    enabled: !!id,
    refetchInterval: (q) => (isTerminal(q.state.data?.status) ? false : 5_000),
  });
}
